// Outline star used by the gallery cards, ranking rows and vote popup
// (no CDN asset for this phase: the Figma glyph ships as inline SVG).
const StarIcon = ({ className, filled = false }: { className?: string; filled?: boolean }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 2.6 14.9 8.7l6.6.8-4.9 4.6 1.3 6.5L12 17.4l-5.9 3.2 1.3-6.5L2.5 9.5l6.6-.8L12 2.6Z" />
  </svg>
)

export default StarIcon
